var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrong(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 11.83c-2.394 2.06-5.753 2.549-10.129 2.523 0 0-.816.251-1.003-.778 0 0-.168-4.558.83-7.758 0 0-.042-1.306.007-2.16a.562.562 0 01.18-.383c1.116-1.03 1.687-1.28 1.801-1.323a.247.247 0 01.045-.012l1.665-.295a.365.365 0 01.26.047c.337.213.6.55.548 1.554a.575.575 0 01-.111.322c-.122.159-.34.376-.559.266-.047.303-.576.519-.928.303-.08.224-.531.21-.894-.092-.167-.138-.567-.083-.53.13.263 1.49 2.815.38 3.223-.232.16-.052.589-.04.673-.031.24.025.406.333.402.58-.002.254-.613.446-.613.446-.462.128-.731.42-1.003.799-.27.378-.664.664-1.946.718.069.31.436 2.286.525 4.075.396-.963 1.449-2.741 3.434-3.022 2.939-.419 4.401 1.854 4.401 1.854s.051.06.115.168c.45.753.272 1.726-.393 2.3z",
    fill: "#8FBB6A"
  })));
}
export default SvgStrong;